import { useAuthStore } from '@/lib/authStore';

export function SettingsPage() {
  const user = useAuthStore((s) => s.user);

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="mt-1 text-text-secondary">Account & dashboard preferences</p>
      </div>

      <section className="card space-y-3">
        <h2 className="text-lg font-bold">Profile</h2>
        <Row label="Name" value={user?.name ?? '—'} />
        <Row label="Username" value={`@${user?.username ?? ''}`} />
        <Row label="Email" value={user?.email ?? '—'} />
        <Row label="Role" value={user?.role ?? '—'} />
        <p className="pt-2 text-sm text-text-muted">
          Edit your profile from the mobile app for now.
        </p>
      </section>

      <section className="card space-y-2">
        <h2 className="text-lg font-bold">Compliance</h2>
        <p className="text-sm text-text-secondary">
          This dashboard meets PIPEDA / Bill 25 minimums. Account deletion + data export are
          available via the mobile app.
        </p>
      </section>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between border-b border-border-subtle pb-2 last:border-0 last:pb-0">
      <span className="text-sm text-text-muted">{label}</span>
      <span className="text-sm font-semibold">{value}</span>
    </div>
  );
}
